import React, { useRef, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import licensingImg from './img/licensing-cropped.jpg';
import licensingMobile from './img/licensing-heading-mobile.jpg';
import { Wrapper, Heading, HeadingImg, HeadingContent, Title, Description } from './index.styled';
import { useMobileBreakpoint } from '../breakpoints';
import HtmlText from '../HtmlText';
import { useTranslation } from 'react-i18next';

const resolutions = {
  mobile: { height: '150px', width: '335px' },
  desktop: { width: '530px', height: '340px' }
}

const CONTENT = 'HomePage.LicensingData';

export const LicensingWithUs = () => {
  const isMobile = useMobileBreakpoint();
  const headingRef = useRef(null);
  const titleRef = useRef(null);
  const imgRef = useRef(null);
  const descriptionRef = useRef(null);
  const headingContentRef = useRef(null);
  const { t } = useTranslation();
  const { mobile, desktop } = resolutions;
  const imgSize = isMobile ? mobile : desktop;

  useEffect(() => {
    if (isMobile) {
      headingRef.current.insertBefore(titleRef.current, imgRef.current)
    } else{
      headingContentRef.current.insertBefore(titleRef.current, descriptionRef.current)
    }
  })

  return (
    <Wrapper>
      <Fade up>
        <Heading ref={headingRef}>
          <HeadingImg ref={imgRef}>
            <img src={isMobile ? licensingMobile : licensingImg} alt='' role='presentation' />
          </HeadingImg>
          <HeadingContent ref={headingContentRef}>
            <Title ref={titleRef}>{t(`${CONTENT}.title`)}</Title>
            <Description ref={descriptionRef}><HtmlText>{t(`${CONTENT}.description`)}</HtmlText></Description>
          </HeadingContent>
        </Heading>
      </Fade>
    </Wrapper>
  )
}